import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import IdentPopup from './IdentPopup';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    position: 'absolute'
  },
  point: {
    borderRadius: '100%',
    width: 27,
    height: 27,
    border: '5px solid white',
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: 'white',
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0px 1px 5px #00000087'
  },
  searchPoint: {
    extend: 'point',
    background: '#B39426'
  },
  threatPoint: {
    extend: 'point',
    background: '#C03229'
  },
  tempPoint: {
    extend: 'point',
    background: '#8629C0'
  }
}));

type Props = {
  x: number;
  y: number;
  onSelect: (isSearch: boolean) => void;
  onExit: () => void;
  variant: 'search' | 'threat' | 'temp';
};

function IdentPoint({ x, y, onSelect, onExit, variant }: Props) {
  const classes = useStyles();

  const [showPopup, setShowPopup] = React.useState(true);

  React.useEffect(() => {
    setShowPopup(true);
  }, [x, y]);

  return (
    <div style={{ top: y - 14, left: x - 14 }} className={classes.container}>
      <div className={classes[`${variant}Point`]}>1</div>
      {showPopup && (
        <IdentPopup
          onExit={() => {
            setShowPopup(false);
            onExit();
          }}
          onSelect={(isSearch) => {
            setShowPopup(false);
            onSelect(isSearch);
          }}
        />
      )}
    </div>
  );
}

export default IdentPoint;
